
/*
  This mixin require that component implement a data named loadDocuments that contain the function to load datas.
  a data named filters and a data named query. Exemple:
  data () {
   loadDocuments: this.loadPromoteurs,
   filters: {
      name: '',
      profile: {}
   },
   query: {}
  }
 */
import { isEmpty, debounce, isNil } from 'lodash'
import { cleanQuery } from '../utils'

export default {
  data () {
    return {
      loadDocuments: null, // Must be function (query = {}, page = 1, perPage = 20)
      debounceTime: 600,
      opened: false,
      displayAdminFilterPane: false
    }
  },
  methods: {
    beforeResetFilters () {
      return undefined
    },
    inputChange: debounce(function () {
      this.changeFilters(300)
    }, 300),
    resetFilters (e) {
      console.log('resetFilters')
      this.$store.commit('setScrollEl', null)
      this.beforeResetFilters()
      this.query = Object.assign({}, this.initFilters)
      this.filters = Object.assign({}, this.initFilters)
      this.loadDocuments()
    },
    changeFilters: debounce(async function (e) {
      if (!isNil(e)) this.debounceTime = e
      this.$set(this, 'query', Object.assign({}, this.filters))
      if ('sort' in this.filters) {
        delete this.filters.sort
      }
      await this.loadDocuments()
    }, this.debounceTime)
  },
  computed: {
    hasFilter () {
      if (cleanQuery(this.filters) === cleanQuery(this.initFilters)) return false
      for (const key in this.filters) {
        if ((Array.isArray(this.filters[key]) || typeof this.filters[key] === 'object') && !isEmpty(this.filters[key])) {
          return true
        } else if (typeof this.filters[key] !== 'object' && this.filters[key] !== undefined && this.filters[key] !== null && this.filters[key] !== 0 &&
          this.filters[key] !== '') {
          return true
        }
      }
      return false
    }
  },
  created () {
    if (!this.filters && typeof this.filters !== 'object') {
      console.warn('filters must be defined in data and must be an object.')
    }
    if (!this.query && typeof this.query !== 'object') {
      console.warn('query must be defined in data and must be an object.')
    }
    if (this.$route.query && this.enableSaveQuery) {
      Object.assign(this.filters, this.$route.query)
    }
    if (!this.loadDocuments && typeof this.loadDocuments !== 'function') {
      console.warn('loadDocuments must be defined in data and must be a function.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FilterMixin.js